"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

import { setCookie } from "@/services/CookiesService";
import { ProviderIdentifier } from "@/containers/PaymentContainer/PaymentProviderFactory/types";

import { PSP } from "./types";

const VALID_PSP_VALUES: ProviderIdentifier[] = ["macropay", "stripe", "fake"];

export const StorePsp = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const pspParam = searchParams.get("psp");

    if (pspParam) {
      const pspLowerCase = pspParam.toLowerCase();
      if (VALID_PSP_VALUES.includes(pspLowerCase as ProviderIdentifier)) {
        setCookie(PSP, pspLowerCase);
      }
    }
  }, [searchParams]);

  return null;
};
